import { render, staticRenderFns } from "./EducationalScheduleTimeDetails.vue?vue&type=template&id=708fcf83&"
import script from "./EducationalScheduleTimeDetails.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports